import React from 'react';
import { volumes } from '../data/content';
export function WhatsInside() {
  return <section id="contenuto" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-185" data-mp="yvqx52trblli">
      <div className="mx-auto max-w-3xl" data-id="element-186" data-mp="yto92oc602jf">
        <div className="text-center" data-id="element-187" data-mp="kx13jx65c41w">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-188" data-mp="kvzlh8qpqhao">
            5 volumi digitali · PDF ad alta risoluzione
          </span>
          <h2 className="mt-4 font-display text-[1.75rem] font-black leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-189" data-mp="b5deu40z5144">
            <span aria-hidden="true" data-id="element-190" data-mp="fyfztnror28p">⚛️ </span>Cosa trovi dentro il pack{' '}
            <span className="italic text-grape" data-id="element-191" data-mp="26t5vul7u5t3">FISICA PRONTA?</span>
          </h2>
        </div>

        <ol className="mt-12 space-y-4" data-id="element-192" data-mp="75w7t65wfvwu">
          {volumes.map(volume => <li key={volume.number} className="flex items-start gap-4 rounded-2xl bg-cream px-5 py-5 sm:px-6" data-id="element-193" data-mp="3ocgb8rr1y1jv">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-navy font-display text-sm font-bold text-white" data-id="element-194" data-mp="3te5jy0qsy34s">
                {volume.number}
              </span>
              <div data-id="element-195" data-mp="37wxfopylxidh">
                <h3 className="font-display text-base font-bold text-navy sm:text-lg" data-id="element-196" data-mp="3lulxtq1aibeu">
                  Volume {volume.number}: {volume.title}
                </h3>
                <p className="mt-1.5 text-xs leading-relaxed text-navy/55 sm:text-sm" data-id="element-197" data-mp="3htsbh13hx4o2">
                  {volume.text}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}